import React, { useState } from "react";
import { Button, Input, Typography, Flex, Row, Col } from "antd";
import {  SearchOutlined, CheckCircleOutlined } from "@ant-design/icons";
import Footer from "./snipets/Footer";
import TopNavigation from "./snipets/TopNavigation";
import phone  from "../assets/mobile-app-on-phone.png";
import google from "../assets/GetItOnGooglePlay_Badge_Web_color_English.svg";
import apple  from "../assets/Download_on_the_App_Store_Badge_NL_RGB_blk.svg";
import bg     from "../assets/1000221189.png";

const { Title, Text, Paragraph } = Typography;

// ── Landing Page ──────────────────────────────────────────────────────────────

const LandingPage: React.FC = () => {
    const [address, setAddress] = useState("");

    return (
        <>
            <TopNavigation />

            {/* Hero */}
            <div style={{ background: "#f5f5f0", marginTop: 64 }}>
                <Row>
                    <Col xs={24} md={12}>
                        <Flex vertical justify="center" style={{ padding: "64px 48px", height: "100%" }} gap="large">
                            <div>
                                <Title style={{ fontSize: "clamp(26px, 4vw, 40px)", marginBottom: 8 }}>
                                    Order food and more
                                </Title>
                                <Paragraph type="secondary" style={{ fontSize: "clamp(15px, 2vw, 18px)" }}>
                                    Restaurants and grocery stores delivering near you
                                </Paragraph>
                            </div>
                            <Input.Search
                                placeholder="Full address"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                enterButton={<Button type="primary">Search</Button>}
                                size="large"
                                style={{ maxWidth: 460 }}
                            />
                        </Flex>
                    </Col>
                    <Col xs={0} md={12}>
                        <img src={bg} alt="hero" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
                    </Col>
                </Row>
            </div>

            <HowToOrderSection />
            <DownloadAppSection />
            <Footer />
        </>
    );
};

// ── How to Order ──────────────────────────────────────────────────────────────

const steps = [
    {
        icon: <SearchOutlined style={{ fontSize: 24 }} />,
        title: "Tell us where you are",
        desc:  "We'll show you stores and restaurants nearby that you can order from.",
    },
    {
        icon: <SearchOutlined style={{ fontSize: 24 }} />,
        title: "Find what you want",
        desc:  "Search for items or dishes, businesses or cuisines.",
    },
    {
        icon: <CheckCircleOutlined style={{ fontSize: 24 }} />,
        title: "Order for delivery or collection",
        desc:  "We'll update you on your order's progress.",
    },
];

const HowToOrderSection: React.FC = () => (
    <div style={{ background: "#fff", padding: "56px 24px" }}>
        <Flex vertical align="center" style={{ marginBottom: 40 }}>
            <Text type="secondary" style={{ textTransform: "uppercase", letterSpacing: 1, fontSize: 13 }}>
                How to order
            </Text>
            <Title level={2} type="success" style={{ margin: 0 }}>It's as easy as this.</Title>
        </Flex>

        <Row gutter={[32, 32]} justify="center">
            {steps.map((step) => (
                <Col xs={24} sm={8} key={step.title} style={{ textAlign: "center" }}>
                    <Flex vertical align="center" gap="middle">
                        <div style={{
                            width: 64, height: 64, borderRadius: "50%",
                            border: "2px solid #00AF66",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            color: "#00AF66",
                        }}>
                            {step.icon}
                        </div>
                        <Title level={5} style={{ margin: 0 }}>{step.title}</Title>
                        <Text type="secondary" style={{ maxWidth: 200, lineHeight: 1.7, display: "block" }}>
                            {step.desc}
                        </Text>
                    </Flex>
                </Col>
            ))}
        </Row>
    </div>
);

// ── Download App ──────────────────────────────────────────────────────────────

const DownloadAppSection: React.FC = () => (
    <div style={{ background: "#dff0ea", padding: "56px 24px", overflow: "hidden" }}>
        <Row gutter={[32, 32]} align="middle" justify="center">
            <Col xs={24} md={10}>
                <Title style={{ fontSize: "clamp(24px, 3vw, 34px)", marginBottom: 8 }}>Download the app</Title>
                <Paragraph type="secondary" style={{ fontSize: 16, marginBottom: 40 }}>
                    Click, sit back, and enjoy.
                </Paragraph>
                <Flex gap={12} wrap="wrap" align="center">
                    <img src={google} alt="Google Play"  style={{ height: 52, objectFit: "contain" }} />
                    <img src={apple}  alt="App Store"    style={{ height: 52, objectFit: "contain" }} />
                </Flex>
            </Col>
            <Col xs={0} md={8}>
                <img
                    src={phone}
                    alt="App on phone"
                    style={{ height: 480, width: "auto", objectFit: "contain", display: "block", marginLeft: "auto", marginTop: -56, marginBottom: -56 }}
                />
            </Col>
        </Row>
    </div>
);

export default LandingPage;